// src/components/PrivateRoute.js
import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../firebase/firebase';
import { Link, Navigate } from 'react-router-dom';
import './PrivateRoute.css';

const PrivateRoute = ({ children }) => {
  const [user, loading] = useAuthState(auth);

  if (loading) return <div className="text-center py-5">🔄 Loading...</div>;

  if (!user) {
    return (
      <div className="container text-center py-5">
        <div className="card p-4 shadow-sm mx-auto" style={{ maxWidth: '500px' }}>
          <h3 className="mb-3 text-danger">🔒 Access Restricted</h3>
          <p className="access-message">
            Please <Link to="/login">Login</Link> or <Link to="/register">Register</Link> to explore all job opportunities and turn on daily Email alerts from your profile anytime!
          </p>
          <div className="d-flex justify-content-center gap-3 mt-3">
            <Link to="/login" className="btn btn-primary">Login</Link>
            <Link to="/register" className="btn btn-primary">Register</Link>
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default PrivateRoute;
